import Row from 'choerodon-ui/lib/grid/row';
import Col from 'choerodon-ui/lib/grid/col';
export { Row, Col, };
